import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as firebase from 'firebase'
import { from } from 'rxjs';
import {GranServicioDePTWService } from '../gran-servicio-de-ptw.service'
import {ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'

@Component({
  selector: 'app-modal-herramientas-ycontroles',
  templateUrl: './modal-herramientas-ycontroles.page.html',
  styleUrls: ['./modal-herramientas-ycontroles.page.scss'],
})
export class ModalHerramientasYControlesPage implements OnInit {

  @Input() actividad;
  @Input() indiceActividad
  // @Input() trabajador
  // @Input() indiceTrabajador
  @Input()arrayActividadesPTW;


  herramientasYControlesTrabajoEnAlturas = {
    herramientas: { arneses: 0, andamios: 0, eslingas: 0, eslingaDePosicionamiento: 0, cascos: 0, tieOff: 0, poleas: 0, descendedor: 0, gibbs: 0, lineaDeVida: 0, arrestador: 0, mosquetones: 0, cuerdas: 0, escaleras: 0, cintaDeAnclaje: 0, pertiga: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: [],
    aspectosAmbientales:[],
    controlesOperacionales:[]
  }

  herramientasYControlesTrabajoEnCaliente = {
    herramientas: { pulidoras: 0, motosoldadores: 0, esmeriles: 0, plantasElectricas: 0, taladrosPercutores: 0, sierras: 0, motosierras: 0, guadanas: 0, otrosChispas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: [],
    aspectosAmbientales:[],
    controlesOperacionales:[]
  }

  herramientasYControlesLevantamientoMecanico = {
    herramientas: { grua: 0, camionBrazoGrua: 0, montacargas: 0, telehandlers: 0, aparejos: 0, gibbs: 0, arrestadores: 0, mosquetones: 0, cuerdas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: [],
    aspectosAmbientales:[],
    controlesOperacionales:[]
  }

  herramientasYControlesEnergiasPeligrosas = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: [],
    aspectosAmbientales:[],
    controlesOperacionales:[]
  }

  herramientasYControlesEspaciosConfinados = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: [],
    aspectosAmbientales:[],
    controlesOperacionales:[]
  } 

  herramientasYControlesHazmat = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: [],
    aspectosAmbientales:[],
    controlesOperacionales:[],
  }

  herramientasYControlesSupervicionYmonitoreo = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: [],
    aspectosAmbientales:[],
    controlesOperacionales:[]
  } 

  herramientasYControlesOtros = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: [],
    aspectosAmbientales:[],
    controlesOperacionales:[]
  } 

        

  constructor(public modalCtrl: ModalController,public granServicioDePTWService:GranServicioDePTWService, public servicioLoadersAlertasService:ServicioLoadersAlertasService) { }

  ngOnInit() {
  }

  cancelar(){
    this.modalCtrl.dismiss({
      actividadActualizada:this.actividad.actividad
    }); 
  }

  ionViewWillEnter(){
    if(this.actividad == 'TRABAJO EN ALTURAS' && this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles != undefined){
        this.herramientasYControlesTrabajoEnAlturas = this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles
    }else
    if(this.actividad == 'TRABAJO EN CALIENTE' && this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles != undefined){
      this.herramientasYControlesTrabajoEnCaliente = this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles
    }else
    if(this.actividad == 'LEVANTAMIENTO MECÁNICO' && this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles != undefined){
      this.herramientasYControlesLevantamientoMecanico = this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles
    }else
    if(this.actividad == 'ENERGÍAS PELIGROSAS' && this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles != undefined){
      this.herramientasYControlesEnergiasPeligrosas = this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles
    }else
    if(this.actividad == 'ESPACIOS CONFINADOS' && this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles != undefined){
      this.herramientasYControlesEspaciosConfinados = this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles
    }else
    if(this.actividad == 'HAZMAT' && this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles != undefined){
      this.herramientasYControlesHazmat = this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles
    }else
    if(this.actividad == 'SUPERVISIÓN Y MONITOREO' && this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles != undefined){
      this.herramientasYControlesSupervicionYmonitoreo = this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles
    }else
    if(this.actividad == 'OTROS' && this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles != undefined){
      this.herramientasYControlesOtros = this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles
    }
    
  }
  

  guardar(){
   this.updateArray(()=>{
     this.updateFirebase()
   })
  }

  updateArray(callback){
    
    if(this.actividad == 'TRABAJO EN ALTURAS'){
      console.log("updateArray ejecutado")
      this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles=this.herramientasYControlesTrabajoEnAlturas
      callback()
    }else
    if(this.actividad == 'TRABAJO EN CALIENTE'){
      console.log("updateArray ejecutado")
      this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles=this.herramientasYControlesTrabajoEnCaliente
      callback()
    }else
    if(this.actividad == 'LEVANTAMIENTO MECÁNICO'){
      console.log("updateArray ejecutado")
      this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles=this.herramientasYControlesLevantamientoMecanico
      callback()
    }else
    if(this.actividad == 'ENERGÍAS PELIGROSAS'){
      console.log("updateArray ejecutado")
      this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles=this.herramientasYControlesEnergiasPeligrosas
      callback()
    }else
    if(this.actividad == 'ESPACIOS CONFINADOS'){
      console.log("updateArray ejecutado")
      this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles=this.herramientasYControlesEspaciosConfinados
      callback()
    }else
    if(this.actividad == 'HAZMAT'){
      console.log("updateArray HAZMAT ejecutado")
      this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles=this.herramientasYControlesHazmat
      callback()
    }else
    if(this.actividad == 'SUPERVISIÓN Y MONITOREO'){
      console.log("updateArray SUPERVISIÓN Y MONITOREO ejecutado")
      this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles=this.herramientasYControlesSupervicionYmonitoreo
      callback()
    }else
    if(this.actividad == 'OTROS'){
      console.log("updateArray ejecutado")
      this.arrayActividadesPTW[this.indiceActividad].herramientasYcontroles=this.herramientasYControlesOtros
      callback()
    }
  }

  updateFirebase(){
    let query = firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud)
    query.update({
      arrayActividadesPTW:this.arrayActividadesPTW
    }).then(()=>{
      this.servicioLoadersAlertasService.presentToast("¡Herramientas y controles guardados!")
      this.modalCtrl.dismiss({
        actividadActualizada:this.actividad
      })
    })
  }



}
